import { ButtonBase, Stack, Typography } from '@mui/material'
import truncate from 'lodash/truncate'
import { Icons } from 'utoniq-ui'

import { Maybe } from '@/clients/utoniq-core/schema'
import { useMessage, useTranslation } from '@/core'

export const TokenId = ({
  tokenId,
  variant = 'subtitle1',
  withTitle,
}: {
  tokenId?: Maybe<string>
  variant?: 'subtitle1' | 'subtitle2'
  withTitle?: boolean
}) => {
  const { t } = useTranslation('nftItems')
  const { showMessage } = useMessage()

  const iconSize = {
    subtitle1: {
      height: 16,
      width: 16,
    },
    subtitle2: {
      height: 12,
      width: 12,
    },
  }

  return (
    <Stack direction="row">
      <ButtonBase
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()
          navigator.clipboard
            .writeText(tokenId ?? '')
            .then(() => showMessage(t('tokenIdCopied')))
        }}
        /**
         * Unaffected by parent component ripple
         */
        onTouchStart={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Typography variant={variant}>
          {withTitle && t('tokenId')}
          {tokenId ? truncate(tokenId, { length: 8 }) : t('issuing')}
        </Typography>
        <Icons.Copy sx={{ alignSelf: 'center', ml: 1, ...iconSize[variant] }} />
      </ButtonBase>
    </Stack>
  )
}
